import { Label } from 'components/Label';
import { GameState } from 'data/generated';
import styled from 'styled-components';
import { Colors } from 'styles/colors';

function getGameStateTagColors(state: GameState): {
    tagColor: string;
    tagTextColor?: string;
} {
    switch (state) {
        case GameState.Created:
            return { tagColor: Colors.secondary.blue };
        case GameState.Started:
            return { tagColor: Colors.secondary.yellow };
        case GameState.Completed:
            return { tagColor: Colors.secondary.green };
    }
}

export const GameStateTag = ({ state, label }: { state: GameState; label?: string }) => {
    const { tagColor, tagTextColor = Colors.primary.white } = getGameStateTagColors(state);
    return (
        <Container>
            {label && <Label>{label}</Label>}
            <Tag tagColor={tagColor} tagTextColor={tagTextColor}>
                {state}
            </Tag>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

const Tag = styled.div<{ tagColor: string; tagTextColor: string }>`
    font-size: 14px;
    color: ${({ tagTextColor }) => tagTextColor};
    background-color: ${({ tagColor }) => tagColor};
    width: min-content;
    padding: 5px 10px;
    border-radius: 10px;
`;
